import { API_ORIGIN } from './client';

export interface ProApplicationResult {
  id: string;
  status: string;
  created_at: string;
}

export async function submitProApplication(payload: {
  credentials: string;
  evidenceFile?: File | null;
}): Promise<ProApplicationResult> {
  const token = localStorage.getItem('nanikiru_token');
  const formData = new FormData();
  formData.append('credentials', payload.credentials);
  formData.append('message', '');
  if (payload.evidenceFile) {
    formData.append('evidence_file', payload.evidenceFile);
  }

  const res = await fetch(`${API_ORIGIN}/api/v1/pro-applications`, {
    method: 'POST',
    credentials: 'include',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail ?? `HTTP ${res.status}`);
  }
  return res.json();
}

export async function getMyProApplication(): Promise<ProApplicationResult | null> {
  const token = localStorage.getItem('nanikiru_token');
  const res = await fetch(`${API_ORIGIN}/api/v1/pro-applications/me`, {
    credentials: 'include',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) return null;
  return res.json();
}
